var map = {
	"./": [
		"12cb"
	],
	"./cn": [
		"c8fa",
		"chunk-2d2180a6"
	],
	"./cn.js": [
		"c8fa",
		"chunk-2d2180a6"
	],
	"./en": [
		"b7d1",
		"chunk-2d210818"
	],
	"./en.js": [
		"b7d1",
		"chunk-2d210818"
	],
	"./es": [
		"a6bb",
		"chunk-2d208feb"
	],
	"./es.js": [
		"a6bb",
		"chunk-2d208feb"
	],
	"./index": [
		"12cb"
	],
	"./index.js": [
		"12cb"
	],
	"./pt": [
		"4d09"
	],
	"./pt.js": [
		"4d09"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2e98";
module.exports = webpackAsyncContext;